import { render } from "./official-member.vue?vue&type=template&id=40a2e43d&scoped=true"
import script from "./official-member.vue?vue&type=script&lang=js"
export * from "./official-member.vue?vue&type=script&lang=js"

import "./official-member.vue?vue&type=style&index=0&id=40a2e43d&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a2e43d"]])

export default __exports__